import React, { useEffect, useState } from "react";
import "./login.scss";
import LoginForm from "../components/Login/LoginForm";
import fondoLogin from "../assets/fondoLogin.jpg";
import CambioDatos from "../components/Login/CambioDatos";
const Login = () => {
  const [cambioDatos, setcambioDatos] = useState(false);

  useEffect(() => {
    const boton = document.getElementById("cari_button");
    if (boton) {
      boton.style.display = "none" ;
    }
  }, []);

  return (
    <>
      {!cambioDatos ? (
        <div
          className="login-background"
          style={{
            backgroundImage: `url(${fondoLogin})`,
            backgroundRepeat: "no-repeat",
            backgroundAttachment:"fixed",
            backgroundSize: "cover",
            display: "grid",
            placeItems: "end",
            }}
        >
          <LoginForm setcambioDatos={setcambioDatos}/>
        </div>
      ) : (
        <div
          className="login-background"
        >
          <CambioDatos setcambioDatos={setcambioDatos}/>
        </div>
      )}
    </>
  );
};

export default Login;
